import { Dog } from "lucide-react";
import { displayValue, formatDate } from "../helpers";
import { Attribute, EmptySection } from "./SectionPrimitives";

export function PackagesSection({ packages }) {
  if (!packages.length) {
    return <EmptySection>Nenhum pacote ativo encontrado.</EmptySection>;
  }

  return (
    <div className="pt-3 pb-6 gap-3 flex flex-wrap">
      {packages.map((packageData, index) => (
        <article
          className="rounded-lg border border-gray-200 bg-background min-w-fit flex-1"
          key={packageData.id || index}
        >

          <div className="mb-4 flex flex-wrap items-start justify-between gap-2 border-b border-gray-100 p-4">
            <h3 className="font-semibold items-center text-base text-gray-800 flex gap-2">
              <Dog size={18} />{displayValue(packageData.petName)}
            </h3>
            <p className="flex items-center text-base gap-2">
              <span className="font-semibold">Pacote:</span>{displayValue(packageData.name)}
            </p>
            <span className="rounded-full  bg-success px-3 py-1 text-xs font-semibold text-white">
              {displayValue(packageData.status, "Ativo")}
            </span>
          </div>
          <dl className="grid grid-cols-2 gap-4 md:grid-cols-3 px-4 pb-4">
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Departamento</span>
              <p className="flex gap-1 text-sm text-gray-800">   {displayValue(packageData.department)}</p>
            </div>
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Quantidade disponível</span>
              <p className="flex gap-1 text-sm text-gray-800">   {displayValue(packageData.quantityAvailable)}</p>
            </div>
            <div>
              <span className="mb-1 flex items-center gap-2 text-sm font-semibold  text-gray-500">Validade</span>
              <p className="flex gap-1 text-sm text-gray-800">{formatDate(packageData.expiresAt)}</p>
            </div>
          </dl>
        </article>
      ))}
    </div>
  );
}
